//frontend/src/components/TopBar1.js
import React, { useState, useEffect } from 'react';
import { FaBars, FaUser, FaSignOutAlt, FaBell, FaChevronDown, FaBoxOpen, FaTrash, FaBroom } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axios';
import UserProfile from './UserProfile';
import '../styles/admin.css';

const TopBar = ({ toggleSidebar }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [deletingNotifId, setDeletingNotifId] = useState(null);
  const navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState({
    username: 'Админ',
    fullname: 'Админ хэрэглэгч',
    email: 'admin@jimgun.mn',
    image: ''
  });

  const [adminSettings, setAdminSettings] = useState({
    admin_logo: '/logo.png',
    admin_company_name: 'Жим Гүн Трэйд ХХК'
  });

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const response = await axiosInstance.get('/api/users/me');
        if (response.data.success) {
          const user = response.data.data;
          setCurrentUser({
            username: user.username || 'Админ',
            fullname: user.fullname || 'Админ хэрэглэгч',
            email: user.email || 'admin@jimgun.mn',
            image: user.image || ''
          });
        }
      } catch (error) {
        console.error('Fetch current user error:', error);
      }
    };
    fetchCurrentUser();
  }, []);

  const fetchNotifications = async () => {
    try {
      const [countRes, recentRes] = await Promise.all([
        axiosInstance.get('/api/notifications/unread-count'),
        axiosInstance.get('/api/notifications/recent')
      ]);
      
      if (countRes.data.success) {
        setUnreadCount(countRes.data.count);
      }
      
      if (recentRes.data.success) {
        setNotifications(recentRes.data.data || []);
      }
    } catch (error) {
      console.error('Fetch notifications error:', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchAdminSettings = async () => {
      try {
        const response = await axiosInstance.get('/api/settings/public/all');
        if (response.data.success) {
          const data = response.data.data;
          setAdminSettings({
            admin_logo: data.admin_logo || '/logo.png',
            admin_company_name: data.admin_company_name || 'Жим Гүн Трэйд ХХК'
          });
        }
      } catch (error) {
        console.error('Fetch admin settings error:', error);
      }
    };
    fetchAdminSettings();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setShowUserMenu(false);
        setShowNotifications(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDeleteNotification = async (notificationId, e) => {
    e.stopPropagation();
    
    if (!window.confirm('Энэ мэдэгдлийг устгах уу?')) {
      return;
    }
    
    setDeletingNotifId(notificationId);
    try {
      await axiosInstance.delete(`/api/notifications/${notificationId}`);
      fetchNotifications();
    } catch (error) {
      console.error('Delete notification error:', error);
      alert(error.response?.data?.msg || 'Устгахад алдаа гарлаа');
    } finally {
      setDeletingNotifId(null);
    }
  };

  const handleClearReadNotifications = async () => {
    if (!window.confirm('Уншсан бүх мэдэгдлийг устгах уу?')) {
      return;
    }
    
    try {
      await axiosInstance.delete('/api/notifications/clear-read');
      fetchNotifications();
      alert('✅ Уншсан мэдэгдлүүд цэвэрлэгдлээ');
    } catch (error) {
      console.error('Clear read notifications error:', error);
      alert(error.response?.data?.msg || 'Цэвэрлэхэд алдаа гарлаа');
    }
  };

  const handleNotificationClick = async (notification) => {
    try {
      await axiosInstance.patch(`/api/notifications/${notification.id}/read`);
      fetchNotifications();
      navigate(`/admin/cargo-requests?notification_id=${notification.id}&cargo_id=${notification.reference_id}`);
      setShowNotifications(false);
    } catch (error) {
      console.error('Mark as read error:', error);
    }
  };

  const handleMarkAllRead = async () => {
    try {
      await axiosInstance.patch('/api/notifications/mark-all-read');
      fetchNotifications();
    } catch (error) {
      console.error('Mark all read error:', error);
    }
  };

  // ✅ ЗАСАГДСАН LOGOUT ФУНКЦ
  const handleLogout = async () => {
    try {
      // Backend руу logout request илгээж cookie устгах
      await axiosInstance.post('/api/logout');
      
      // localStorage цэвэрлэх (хэрэв ашиглаж байвал)
      localStorage.removeItem('token');
      
      // Login хуудас руу шилжих
      navigate('/login');
      
      console.log('✅ Logout амжилттай');
    } catch (error) {
      console.error('❌ Logout алдаа:', error);
      
      // Алдаа гарсан ч logout хийх
      localStorage.removeItem('token');
      navigate('/login');
    }
  };

  const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Дөнгөж сая';
    if (diffMins < 60) return `${diffMins} минутын өмнө`;
    
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours} цагийн өмнө`;
    
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} өдрийн өмнө`;
  };

  return (
    <>
      <header className="admin-topbar">
        <div className="w-full flex items-center justify-between">
          
          <div className="flex items-center space-x-2 sm:space-x-4">
            <button
              onClick={toggleSidebar}
              className="hamburger"
              aria-label="Toggle sidebar"
            >
              <FaBars />
            </button>
            
            <div className="topbar-brand flex items-center space-x-2 sm:space-x-3">
              <img 
                src={adminSettings.admin_logo} 
                alt="Logo" 
                className="topbar-logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <span className="topbar-brand-text hidden sm:block">
                {adminSettings.admin_company_name}
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-4">
            <div className="dropdown-container relative">
              <button 
                onClick={() => {
                  setShowNotifications(!showNotifications);
                  setShowUserMenu(false);
                }}
                className="notification-btn"
              >
                <FaBell className="w-4 h-4 sm:w-5 sm:h-5" />
                {unreadCount > 0 && (
                  <span className="notification-badge">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </button>

              {showNotifications && (
                <div className="notification-dropdown">
                  <div className="notification-header">
                    <h3 className="text-base font-bold text-gray-800">Мэдэгдэл</h3>
                    <div className="flex items-center gap-2 text-xs">
                      {unreadCount > 0 && (
                        <button 
                          onClick={handleMarkAllRead}
                          className="text-blue-600 hover:text-blue-800 font-semibold"
                        >
                          Бүгдийг унших
                        </button>
                      )}
                      {notifications.some(n => n.is_read) && (
                        <>
                          <span className="text-gray-300">|</span>
                          <button 
                            onClick={handleClearReadNotifications}
                            className="text-xs text-red-600 hover:text-red-800 font-semibold flex items-center gap-1"
                            title="Уншсан мэдэгдлийг устгах"
                          >
                            <FaBroom className="text-xs" />
                            Цэвэрлэх
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="notification-list">
                    {notifications.length === 0 ? (
                      <div className="text-center py-8 text-gray-500">
                        <FaBell className="mx-auto text-4xl mb-2 opacity-30" />
                        <p className="text-sm">Шинэ дуудлага байхгүй</p>
                      </div>
                    ) : (
                      notifications.map(notification => (
                        <div 
                          key={notification.id} 
                          className={`notification-item ${!notification.is_read ? 'bg-blue-50' : ''} cursor-pointer relative group`}
                          onClick={() => handleNotificationClick(notification)}
                        >
                          <div className="flex items-start gap-3">
                            <div className="flex-shrink-0 text-2xl">
                              <FaBoxOpen className="text-blue-600" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="notification-message font-semibold">
                                {notification.title}
                              </div>
                              {notification.message && (
                                <div className="text-xs text-gray-600 mt-1">
                                  {notification.message.substring(0, 60)}
                                  {notification.message.length > 60 && '...'}
                                </div>
                              )}
                              <div className="notification-time">
                                {getTimeAgo(notification.created_at)}
                              </div>
                            </div>
                            {!notification.is_read && (
                              <div className="flex-shrink-0">
                                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                              </div>
                            )}
                            <button
                              onClick={(e) => handleDeleteNotification(notification.id, e)}
                              disabled={deletingNotifId === notification.id}
                              className="absolute right-2 top-2 opacity-0 group-hover:opacity-100 transition-opacity p-1.5 hover:bg-red-100 rounded-full text-red-600 hover:text-red-700"
                              title="Устгах"
                            >
                              {deletingNotifId === notification.id ? (
                                <div className="animate-spin rounded-full h-3 w-3 border-2 border-red-600 border-t-transparent"></div>
                              ) : (
                                <FaTrash className="w-3 h-3" />
                              )}
                            </button>
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                  {notifications.length > 0 && (
                    <div className="notification-footer">
                      <button 
                        onClick={() => {
                          navigate('/admin/cargo-requests');
                          setShowNotifications(false);
                        }}
                        className="notification-see-all"
                      >
                        Бүгдийг харах →
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="dropdown-container relative">
              <button
                onClick={() => {
                  setShowUserMenu(!showUserMenu);
                  setShowNotifications(false);
                }}
                className="profile-btn"
              >
                <div className="profile-avatar">
                  {currentUser.image ? (
                    <img
                      src={`${window.location.origin}${currentUser.image}`}
                      alt={currentUser.username}
                      className="w-full h-full rounded-full object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        if (e.target.nextElementSibling) {
                          e.target.nextElementSibling.style.display = 'flex';
                        }
                      }}
                    />
                  ) : null}
                  <div 
                    className="w-full h-full flex items-center justify-center"
                    style={{ display: currentUser.image ? 'none' : 'flex' }}
                  >
                    <FaUser className="w-3 h-3 sm:w-4 sm:h-4" />
                  </div>
                </div>
                <span className="profile-name">
                  {currentUser.username}
                </span>
                <FaChevronDown className={`profile-arrow ${showUserMenu ? 'rotate-180' : ''}`} />
              </button>

              {showUserMenu && (
                <div className="profile-dropdown">
                  <div className="profile-dropdown-header">
                    <div className="profile-avatar-large">
                      {currentUser.image ? (
                        <img
                          src={`${window.location.origin}${currentUser.image}`}
                          alt={currentUser.username}
                          className="w-full h-full rounded-full object-cover"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            if (e.target.nextElementSibling) {
                              e.target.nextElementSibling.style.display = 'flex';
                            }
                          }}
                        />
                      ) : null}
                      <div 
                        className="w-full h-full flex items-center justify-center"
                        style={{ display: currentUser.image ? 'none' : 'flex' }}
                      >
                        <FaUser className="w-5 h-5" />
                      </div>
                    </div>
                    <div>
                      <div className="profile-dropdown-name">{currentUser.fullname}</div>
                      <div className="profile-dropdown-email">{currentUser.email}</div>
                    </div>
                  </div>

                  <div className="profile-dropdown-menu">
                    <button 
                      className="profile-dropdown-item"
                      onClick={() => {
                        setShowProfileModal(true);
                        setShowUserMenu(false);
                      }}
                    >
                      <FaUser className="w-4 h-4" />
                      Профайл
                    </button>
                    
                    <hr className="profile-dropdown-divider" />
                    
                    <button
                      onClick={handleLogout}
                      className="profile-dropdown-item text-red-600 hover:bg-red-50"
                    >
                      <FaSignOutAlt className="w-4 h-4" />
                      Гарах
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {showProfileModal && (
        <UserProfile 
          onClose={() => setShowProfileModal(false)}
          onSave={() => {
            axiosInstance.get('/api/users/me').then(res => {
              if (res.data.success) {
                const user = res.data.data;
                setCurrentUser({
                  username: user.username || 'Админ',
                  fullname: user.fullname || 'Админ хэрэглэгч',
                  email: user.email || 'admin@jimgun.mn',
                  image: user.image || ''
                });
              }
            }).catch(err => console.error('Refresh user error:', err));
          }}
        />
      )}
    </>
  );
};

export default TopBar;